import api from '../../api';

const essentialsModule = {
  state: {
    apps: []
  },
  getters: {
    myEssentialsApps: state => state.apps
  },
  mutations: {
    SET_MY_ESSENTIALS_APPS: function (state, apps) {
      state.apps = apps;
    }
  },
  actions: {
    fetchMyEssentialsApps: function ({commit}) {
      if (!this.getters.isLoading) {
        commit('SET_IS_LOADING', true);
      }

      api.essentials.fetchApps(123)
        .then((response) => {
          return commit('SET_MY_ESSENTIALS_APPS', response);
        })
        .finally(() => {
          if (this.getters.isLoading) {
            commit('SET_IS_LOADING', false);
          }
        });
    },
  }
};

export default essentialsModule;
